
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter2Off as ObiFilter2OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-2-off.js';
 
 
 

 
 export const ObiFilter2Off = createComponent({
   react: React,
   tagName: 'obi-filter-2-off',
   elementClass: ObiFilter2OffElement,
   events: {
     
   }
  });
 
 